import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import {unregister} from "./registerServiceWorker";
import WebFont from "webfontloader";

WebFont.load({
  google: {
    families: ["Titillium Web:300,400,600,700", "sans-serif"]
  }
});

ReactDOM.render(<App />, document.getElementById("root"));

unregister();



// WEBPACK FOOTER //
// ./src/index.js